import { Box } from '@mui/material'
import Grid from "@mui/material/Grid2";
import { useEffect, useState } from 'react';
import './styles.scss'

export interface summaryState {
  lagunillasTierra: any;
  bachaqueroTierra: any;
}

const SummaryLandOccidente = ({ reportFilters, data }: { reportFilters: any, data: any }) => {

  const [summary, setSummary] = useState<summaryState>()

  const optimizationOptions = [
    { condition: "Buenas Condiciones", key: "buenasCondiciones" },
    { condition: "Interferencia por Gas Critico (<20%)", key: "interferenciaGasCritico" },
    { condition: "Interferencia por Gas Llenado Medio (20% al 50%)", key: "interferenciaGasLlenadoMedio" },
    { condition: "Interferencia por Gas Buen Llenado (50% al 90%)", key: "interferenciaGasBuenLlenado" },
    { condition: "Golpe de Fluido Critico (<20%)", key: "golpeFluidoCritico" },
    { condition: "Golpe de Fluido Llenado Medio (20% al 50%)", key: "golpeFluidoLlenadoMedio" },
    { condition: "Golpe de Fluido Buen Llenado (50% al 90%)", key: "golpeFluidoBuenLlenado" },
    { condition: "pendiente por determinar", key: "pendientePorDeterminar" },
    { condition: "Golpe de Bomba", key: "golpeBomba" },
    { condition: "Deficiente", key: "deficiente" }
  ]

  useEffect(() => {

    if (data) {
      const visited = data?.activitiesShouldBeAnalyzed || []

      const visitedBMLs = visited.filter((item: any) => item?.field === 'Lagunillas' && item?.method === "BM")
      const visitedBCPLs = visited.filter((item: any) => item?.field === 'Lagunillas' && item?.method === "BCP")

      const totalVisitadosBMLs = visitedBMLs?.length || 0
      const potVisitadosBMLs = visitedBMLs.reduce((acc: any, item: any) => acc + (item?.pot || 0), 0)
      const totalVisitadosBCPLs = visitedBCPLs?.length || 0
      const potVisitadosBCPLs = visitedBCPLs.reduce((acc: any, item: any) => acc + (item?.pot || 0), 0)

      const visitedBMLb = visited.filter((item: any) => item?.field === 'Bachaquero' && item?.method === "BM")
      const visitedBCPLb = visited.filter((item: any) => item?.field === 'Bachaquero' && item?.method === "BCP")

      const totalVisitadosBMLb = visitedBMLb?.length || 0
      const potVisitadosBMLb = visitedBMLb.reduce((acc: any, item: any) => acc + (item?.pot || 0), 0)
      const totalVisitadosBCPLb = visitedBCPLb?.length || 0
      const potVisitadosBCPLb = visitedBCPLb.reduce((acc: any, item: any) => acc + (item?.pot || 0), 0)

      const analyzed = data?.analyzed || []

      const analyzedBMLs = analyzed.filter((item: any) => item?.field === 'Lagunillas' && item?.method === "BM")
      const analyzedBCPLs = analyzed.filter((item: any) => item?.field === 'Lagunillas' && item?.method === "BCP")

      const totalAnalizadosBMLs = analyzedBMLs?.length || 0
      const potAnalizadosBMLs = analyzedBMLs.reduce((acc: any, item: any) => acc + (item?.pot || 0), 0)
      const totalAnalizadosBCPLs = analyzedBCPLs?.length || 0
      const potAnalizadosBCPLs = analyzedBCPLs.reduce((acc: any, item: any) => acc + (item?.pot || 0), 0)

      const analyzedBMLb = analyzed.filter((item: any) => item?.field === 'Bachaquero' && item?.method === "BM")
      const analyzedBCPLb = analyzed.filter((item: any) => item?.field === 'Bachaquero' && item?.method === "BCP")

      const totalAnalizadosBMLb = analyzedBMLb?.length || 0
      const potAnalizadosBMLb = analyzedBMLb.reduce((acc: any, item: any) => acc + (item?.pot || 0), 0)
      const totalAnalizadosBCPLb = analyzedBCPLb?.length || 0
      const potAnalizadosBCPLb = analyzedBCPLb.reduce((acc: any, item: any) => acc + (item?.pot || 0), 0)

      const summaryState: any = {
        lagunillasTierra: {
          totalVisitadosBM: totalVisitadosBMLs,
          potVisitadosBM: potVisitadosBMLs,
          totalVisitadosBCP: totalVisitadosBCPLs,
          potVisitadosBCP: potVisitadosBCPLs,
          totalAnalizadosBM: totalAnalizadosBMLs,
          potAnalizadosBM: potAnalizadosBMLs,
          totalAnalizadosBCP: totalAnalizadosBCPLs,
          potAnalizadosBCP: potAnalizadosBCPLs,
        },
        bachaqueroTierra: {
          totalVisitadosBM: totalVisitadosBMLb,
          potVisitadosBM: potVisitadosBMLb,
          totalVisitadosBCP: totalVisitadosBCPLb,
          potVisitadosBCP: potVisitadosBCPLb,
          totalAnalizadosBM: totalAnalizadosBMLb,
          potAnalizadosBM: potAnalizadosBMLb,
          totalAnalizadosBCP: totalAnalizadosBCPLb,
          potAnalizadosBCP: potAnalizadosBCPLb,
        }
      }

      optimizationOptions.forEach((option) => {
        const lagunillasBM = data?.analyzed?.filter((item: any) => item?.field === 'Lagunillas' && item?.subcondicionEquipoFondo === option?.condition && item.method === "BM") || []
        const lagunillasBCP = data?.analyzed?.filter((item: any) => item?.field === 'Lagunillas' && item?.subcondicionEquipoFondo === option?.condition && item.method === "BCP") || []
        const bachaqueroBM = data?.analyzed?.filter((item: any) => item?.field === 'Bachaquero' && item?.subcondicionEquipoFondo === option?.condition && item.method === "BM") || []
        const bachaqueroBCP = data?.analyzed?.filter((item: any) => item?.field === 'Bachaquero' && item?.subcondicionEquipoFondo === option?.condition && item.method === "BCP") || []

        const totalLagunillasBM = lagunillasBM?.length || 0
        const potLagunillasBM = lagunillasBM.reduce((acc: any, item: any) => acc + (item?.pot || 0), 0)
        const totalLagunillasBCP = lagunillasBCP?.length || 0
        const potLagunillasBCP = lagunillasBCP.reduce((acc: any, item: any) => acc + (item?.pot || 0), 0)

        const totalBachaqueroBM = bachaqueroBM?.length || 0
        const potBachaqueroBM = bachaqueroBM.reduce((acc: any, item: any) => acc + (item?.pot || 0), 0)
        const totalBachaqueroBCP = bachaqueroBCP?.length || 0
        const potBachaqueroBCP = bachaqueroBCP.reduce((acc: any, item: any) => acc + (item?.pot || 0), 0)


        summaryState.lagunillasTierra[`${option?.key}BM`] = totalLagunillasBM
        summaryState.lagunillasTierra[`pot_${option?.key}BM`] = potLagunillasBM
        summaryState.lagunillasTierra[`${option?.key}BCP`] = totalLagunillasBCP
        summaryState.lagunillasTierra[`pot_${option?.key}BCP`] = potLagunillasBCP

        summaryState.bachaqueroTierra[`${option?.key}BM`] = totalBachaqueroBM
        summaryState.bachaqueroTierra[`pot_${option?.key}BM`] = potBachaqueroBM
        summaryState.bachaqueroTierra[`${option?.key}BCP`] = totalBachaqueroBCP
        summaryState.bachaqueroTierra[`pot_${option?.key}BCP`] = potBachaqueroBCP

      })
      setSummary(summaryState)
    }

  }, [reportFilters, data])

  const getDate = (date: string) => {
    return new Date(date).toLocaleDateString('es-ES', { day: '2-digit', month: 'long' })
  }


  const FieldHeader = ({ fieldName }: { fieldName: string }) => {

    const iconSize = 40;

    return (
      <>
        <Grid className="header-table" sx={{ textAlign: 'center', fontWeight: 'bold' }}>{fieldName}</Grid>
        <Grid className="icons-header-table">
          <Grid className="icon-header-icon">
            <img src="/assets/icons/well_whisper.svg" alt='logo' height={iconSize} width={iconSize} />
          </Grid>
          <Grid className="icon-header-icon">
            <img src="/assets/icons/barrel.svg" alt='logo' height={iconSize} width={iconSize} />
          </Grid>
          <Grid className="icon-header-icon">
            <img src="/assets/icons/bcp.svg" alt='logo' height={iconSize} width={iconSize} />
          </Grid>
          <Grid className="icon-header-icon">
            <img src="/assets/icons/barrel.svg" alt='logo' height={iconSize} width={iconSize} />
          </Grid>
        </Grid>
      </>

    )
  }

  const LineElementValue = ({ label, valueElements }: { label: string, valueElements: string[] }) => {

    const lagunillasState: any = { ...summary?.lagunillasTierra }
    const bachaqueroState: any = { ...summary?.bachaqueroTierra }

    return (
      <Grid className="main-table">
        <Grid className="header-table" sx={{ textAlign: 'left', fontWeight: 'bold' }}>{label}</Grid>
        <Grid className="row-line">
          {valueElements.map((value, index) => {

            const valueToShow = lagunillasState[value] || 0

            return (
              <Grid key={index} className={valueToShow > 0 ? "row-element" : "row-element-empty"}>
                {valueToShow}
              </Grid>)
          })}
        </Grid>
        <Grid className="row-line">
          {valueElements.map((value, index) => {

            const valueToShow = bachaqueroState[value] || 0

            return (
              <Grid key={index} className={valueToShow > 0 ? "row-element" : "row-element-empty"}>
                {valueToShow}
              </Grid>)
          })}
        </Grid>
      </Grid>)
  }

  return (
    <Box className="SummaryLandOccidente">
      <Grid className="maintitle">
        Resumen de Analisis del {getDate(reportFilters?.startDate)} al {getDate(reportFilters?.endDate)}
      </Grid>
      <Grid className="main-table">
        <Grid />
        <Grid>
          <FieldHeader fieldName="Lagunillas Tierra" />
        </Grid>
        <Grid>
          <FieldHeader fieldName="Bachaquero Tierra" />
        </Grid>
      </Grid>
      <LineElementValue label="Total Visitados" valueElements={['totalVisitadosBM', 'potVisitadosBM', 'totalVisitadosBCP', 'potVisitadosBCP']} />
      <LineElementValue label="Total Analizados" valueElements={['totalAnalizadosBM', 'potAnalizadosBM', 'totalAnalizadosBCP', 'potAnalizadosBCP']} />
      <Grid className="row-title-section">
        <Grid />
        <Grid className="title-section">Por Condicion</Grid>
      </Grid>
      {optimizationOptions.map((option) => (
        <LineElementValue key={option.key} label={option.condition} valueElements={[`${option?.key}BM`, `pot_${option?.key}BM`, `${option?.key}BCP`, `pot_${option?.key}BCP`]} />
      ))}
    </Box>
  )
}

export default SummaryLandOccidente